
import React, {FC} from 'react';
import {useContextRemaining} from 'components/useHolder/remaining';
import {Step} from 'templates/booking/Booking/reducer';

import * as styles from './styles.module.scss';

type ModalHeaderProps = {
	step: Step
}

export const ModalHeader: FC<ModalHeaderProps> = ({step}) => {
	const remaining = useContextRemaining();
	return (
		<div className={styles.header}>
			<span>
				Confirm an appointment
			</span>
			{step === Step.Pricing && (
				<div className={styles.timer}>
					{remaining}
				</div>
			)}
		</div>
	);
};
